import { ParamsType } from './index'

const denormalizer = ({ pageSize, pageNo }: ParamsType) => {
  return {
    pageSize,
    pageNo,
  }
}

export default denormalizer
